import { toast } from "react-toastify";

/**
 * Envía mensaje al usuario de que algo ha fallado
 * @param {String} mensaje 
 * @param {Number} tiempo 
 */
export default function mensajeError(mensaje, tiempo = 1500) {
    toast.error(mensaje, {
        position: "top-right",
        autoClose: tiempo,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
}